'use client';

import styles from './ConfirmDeleteModal.module.css';
import { createPortal } from 'react-dom';

interface ConfirmDeleteModalProps {
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  playlistTitle?: string;
  title?: string;
  message?: string;
}

export default function ConfirmDeleteModal({
  onCancel,
  onConfirm,
  playlistTitle,
  title = "Delete Playlist",
  message = "Are you sure you want to delete this playlist? This action cannot be undone.",
}: ConfirmDeleteModalProps) {
  return createPortal(
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>
          {message} {playlistTitle && <strong>{playlistTitle}</strong>}
        </p>
        <div className={styles.actions}>
          <button className={styles.cancel} onClick={onCancel}>Cancel</button>
          <button className={styles.delete} onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
